//late version 2025_12_01
//new version 2025_12_20

import { useState, useRef, useEffect, forwardRef } from "react"
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { DebugLogger as dlog } from "./Logger.tsx";

//clases
import FormChecker from "../i-classes/formChecker.tsx";

interface Props {
    className?: string,
    value: string | number,
    SetValue: any,
    onChange?: any, //custom defined changeFunction
    onBlur?: any, //custom defined blurFunction
    readOnly?: boolean,
    type?: string, //string, text, number
    placeholder?: string,
    disabled?: boolean,
    clearOnFocus?: boolean,
    fillOnBlur?: string | number,
    key?: string,
    minLength?: number,
    maxLength?: number,
    requiredMessage?: string,
    formCheckersRef?: React.MutableRefObject<FormChecker[]>
}

const Input = forwardRef<HTMLInputElement, Props>(
    ({ className, value, SetValue, onChange, onBlur, readOnly, type, placeholder, disabled, clearOnFocus, fillOnBlur, key, minLength, maxLength, requiredMessage, formCheckersRef }, ref) =>
    {
        const [passwordVisible, SetPasswordVisible] = useState<boolean>(false);
        const formCheckerIDRef = useRef<string | null>(null);

        //watcehers
        //initialize formChecker
        useEffect(() => {
            if(formCheckersRef && requiredMessage && !formCheckerIDRef.current) {
                const formChecker = new FormChecker(formCheckersRef.current, false, requiredMessage);
                formCheckerIDRef.current = formChecker.id;
                formCheckersRef.current.push(formChecker);
            }
        }, []);
        //watch for value updateAssociatedFormChecker
        useEffect(() => {
            if(formCheckersRef) {
                if(typeof value == 'string') {
                    //update formChecker
                    UpdateAssociatedFormChecker(value.trim().length == 0 ? false : true);
                } else if(typeof value == 'number') {
                    //update formChecker
                    UpdateAssociatedFormChecker(value.toString().trim().length == 0 ? false : true);
                }
            }
        }, [value]);

        //exe functions
        const UpdateAssociatedFormChecker = (value: boolean) => {
            if(formCheckersRef) {
                //look for associated checker
                formCheckersRef.current.map((checker: FormChecker, i: number) => {
                    if(checker.id == formCheckerIDRef.current) {
                        //checker found, updateChecker
                        checker.value = value;
                        //update checkerList
                        formCheckersRef.current.splice(i, 1, checker);
                    }
                });
            }
        }

        return (
            <div className={className ? className : ''} style={{ display: 'flex' }}>
                <input
                    key={key}
                    ref={ref}
                    className='Input-in'
                    style={{
                        position: 'relative', width: 'inherit', height: 'inherit', flex: 'inherit', display: 'inherit',
                        backgroundColor: 'transparent', borderWidth: '0', boxShadow: 'none',
                        fontFamily: 'inherit', color: 'inherit', fontSize: 'inherit', textAlign: 'inherit', textDecoration: 'inherit', fontStyle: 'inherit', lineHeight: 'inherit', whiteSpace: 'inherit', wordBreak: 'inherit' 
                    }}
                    type={
                        type != undefined ?
                            (
                                type == 'visible-password' ?
                                    (
                                        passwordVisible ? 'text' : 'password'
                                    )
                                    :
                                    type
                            )
                            :
                            (typeof value === 'string' ? 'text' : 'number')
                    }
                    value={value}
                    onChange={(e: any) => {
                        if(onChange)
                            onChange(e);
                        else if(e.target != undefined)
                            SetValue(e.target.value);
                    }}
                    onBlur={(e: any) => {
                        if (e.target != undefined) {
                            (onBlur ? onBlur(e) : SetValue(e.target.value.trim()))

                            if (e.target.value.trim().length == 0 && fillOnBlur != undefined)
                                SetValue(fillOnBlur);
                        }
                    }}
                    onFocus={() => { if(clearOnFocus)SetValue('') }}
                    inputMode={(typeof value === 'string' ? 'text' : 'numeric')}
                    readOnly={readOnly == undefined ? false : readOnly}
                    placeholder={(placeholder ? placeholder : '')}
                    disabled={disabled == undefined ? false : disabled}
                    minLength={minLength? minLength : -1} maxLength={maxLength? maxLength : -1}
                />
                {
                    type == 'visible-password' ?
                    <button onClick={() => SetPasswordVisible(!passwordVisible)}>{passwordVisible ? <VisibilityIcon /> : <VisibilityOffIcon/>}</button>
                    :
                    null
                }
            </div>
        )
    });
export default Input;